import styled from 'styled-components';

export const OutputView = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const OutputBody = styled.div`
  flex: 1;
  padding: 25px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
`;
